require('../bootstrap');

import env from '../config/env';
import router from  '../router/index'

const baseURL = env.baseURL;
const normalURL = env.normalURL;
const loginType = env.loginType;
const frontUrl = env.frontUrl;


const store = {
    state: {
        user: {
            name: '',
            picture: '',
            job: '',
            email: '',
            id: 0,
            type_id: null
        },
        authenticated: false,
        trial: false,
        token: '',
        api: baseURL,
        url: normalURL,
        frontUrl: frontUrl,
        breadcrumbs: [{ name: "Home", route: "/" }],
        loginType: loginType
    },
    getters: {
        token: state => {
            return state.token;
        },
        authenticated: state => {
            if (state.token == null || state.token == 'null') {
                return false;
            }

            return state.authenticated;
        },
        logo: state => {
            return state.logo;
        },
        user: state => {
            return state.user;
        },
        trial: state => {
            return state.trial;
        },
        api: state => {
            return state.api;
        },
        url: state => {
            return state.url;
        },
        breadcrumbs: state => {
            return state.breadcrumbs;
        },
        loginRoute: state => {
            return state.loginType == 'default' ? 'login-email' : 'login'
        }
    },
    mutations: {
        auth(state, data) {
            if (data.token != null && data.token != undefined) {
                state.authenticated = true;
                state.token = data.token;
                state.trial = data.trial

                localStorage.clear();
                localStorage.setItem('token', data.token);
                localStorage.setItem('type_id', data.type_id);
                localStorage.setItem('trial', data.trial);

                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('token');
                this.commit('profileUpdate');
            }
        },
        profileUpdate(state) {
            axios.post(state.api + 'me', {
                token: state.token
            })
                .then(response => {
                    state.user.id = response.data.id;
                    state.user.name = response.data.name;
                    state.user.email = response.data.email;
                    state.user.picture = response.data.photo;
                    state.user.type_id = response.data.type_id;

                    localStorage.setItem('type_id', state.user.type_id);
                })
                .catch(error => {
                    localStorage.clear();

                    if(state.loginType == 'default'){

                        router.push('/login-email');
                    } else {
                        router.push('/login');
                    }
                });
        },
        updateBreadCrumbs(state, newRoute) {
            if (state.breadcrumbs.length > 1) {
                state.breadcrumbs.pop();
            }
            state.breadcrumbs.push(newRoute)
            // state.breadcrumbs = newRoute;
        }
    },
    actions: {
        initialize(context) {
            const token = localStorage.getItem('token');
            const type_id = localStorage.getItem('type_id');

            context.commit('auth', {token: token, type_id: type_id});
        }
    }
};

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js